import apiClient from './apiClient';

// AUDIT-LOG v1
export async function getAuditLog(params) {
  const res = await apiClient.get('/audit-log', { params });
  return res.data.data;
}
